import { useQuery } from '@tanstack/react-query';

import type { DirectoryProfileConfig } from './types';

function getQueryKey(appId: string) {
  return ['directoryProfileConfig', appId] as const;
}

function getQueryFn(appId: string) {
  return async (): Promise<DirectoryProfileConfig> => {
    try {
      const module = (await import(`./schemas/directory-profile-config-${appId}.schema.ts`)) as {
        default: DirectoryProfileConfig;
      };

      return module.default;
    } catch {
      const { default: defaults } = await import('./schemas/directory-profile-config-default.schema');
      return defaults;
    }
  };
}

export function useDirectoryProfileConfig(appId: string): DirectoryProfileConfig | null {
  const { data } = useQuery({
    queryKey: getQueryKey(appId),
    queryFn: getQueryFn(appId),
    enabled: Boolean(appId),
  });

  return data ?? null;
}
